import axios from 'axios'

// In dev this is proxied by Vite (see vite.config.ts) to the local apps/api server.
// In prod, API_URL must point to wherever apps/api is deployed.
const baseURL = process.env.API_URL || '/api'

export const creativeApi = axios.create({
  baseURL,
  timeout: 120000, // video generation (Puppeteer + ffmpeg) can take a while
})
